import React from "react";
import * as LucideIcons from "lucide-react";
import "../styles/ServiceCategorie/ServiceCategories.css"; // Make sure this path is correct

const categories = [
  { name: "Home Cleaning", icon: "Home", description: "Deep cleaning, maintenance", services: "12 services", color: "bg-blue-100 text-blue-600", href: "#" },
  { name: "Repairs & Maintenance", icon: "Wrench", description: "Plumbing, electrical, carpentry", services: "18 services", color: "bg-orange-100 text-orange-600", href: "#" },
  { name: "Beauty & Wellness", icon: "Sparkles", description: "Spa, salon, fitness", services: "15 services", color: "bg-pink-100 text-pink-600", href: "#" },
  { name: "Electrical Services", icon: "Zap", description: "Wiring, fixtures, repairs", services: "8 services", color: "bg-yellow-100 text-yellow-600", href: "#" },
  { name: "Vehicle Services", icon: "Car", description: "Car wash, repair, maintenance", services: "10 services", color: "bg-green-100 text-green-600", href: "#" },
  { name: "Tech Support", icon: "Laptop", description: "Computer, phone, TV setup", services: "7 services", color: "bg-purple-100 text-purple-600", href: "#" },
  { name: "Men's Grooming", icon: "Scissors", description: "Haircut, beard, massage", services: "6 services", color: "bg-indigo-100 text-indigo-600", href: "#" },
  { name: "Laundry & Dry Clean", icon: "Shirt", description: "Wash, iron, dry cleaning", services: "5 services", color: "bg-cyan-100 text-cyan-600", href: "#" },
  { name: "Painting Services", icon: "Paintbrush", description: "Interior, exterior painting", services: "4 services", color: "bg-rose-100 text-rose-600", href: "#" },
  { name: "Photography", icon: "Camera", description: "Event, portrait, product", services: "6 services", color: "bg-emerald-100 text-emerald-600", href: "#" },
  { name: "Packers & Movers", icon: "Truck", description: "Home, office relocation", services: "3 services", color: "bg-amber-100 text-amber-600", href: "#" },
  { name: "Event Services", icon: "Users", description: "Party, wedding, corporate", services: "9 services", color: "bg-violet-100 text-violet-600", href: "#" },
];

const ServiceCategories = () => {
  return (
    <section className="service-section">
      <div className="container">
        {/* Header */}
        <div className="header-text">
          <h2>Upcoming Service Categories</h2>
          <p>
            Explore our wide range of professional home services available at your convenience.
          </p>
        </div>

        {/* Main Grid */}
        <div className="grid-container">
          {categories.map((category, index) => {
            const [bgColor, textColor] = category.color.split(" ");
            const IconComponent = LucideIcons[category.icon];
            return (
              <a key={index} href={category.href} className="category-link">
                <div className="card">
                  <div className={`card-icon-wrapper ${bgColor}`}>
                    {IconComponent && <IconComponent className={textColor} size={24} />}
                  </div>
                  <h3>{category.name}</h3>
                  <p className="description">{category.description}</p>
                  <p className="services">{category.services}</p>
                </div>
              </a>
            );
          })}
        </div>

        {/* Popular Section */}
        <div className="popular-section">
          <div className="header-text">
            <h3>Most Popular This Week</h3>
            <p>Trending services booked by customers</p>
          </div>
          <div className="popular-grid-container">
            {categories.slice(0, 3).map((category, index) => {
              const [bgColor, textColor] = category.color.split(" ");
              const IconComponent = LucideIcons[category.icon];
              return (
                <a key={index} href={category.href} className="popular-card-link">
                  <div className="popular-card">
                    <div className={`popular-icon-wrapper ${bgColor}`}>
                      {IconComponent && <IconComponent className={textColor} size={32} />}
                    </div>
                    <div>
                      <h4>{category.name}</h4>
                      <p>{category.description}</p>
                      <p className="services">{category.services}</p>
                    </div>
                  </div>
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceCategories;